import React from "react";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";

import { useRouteMatch, Switch, Route } from "react-router";
import { push } from "connected-react-router";

import PreviewVersionBlade  from "widgets/modals/versions/PreviewVersionBlade";
import EditVersionBlade  from "widgets/modals/versions/EditVersionBlade";
// import SocialVersionBlade from "widgets/modals/versions/social/SocialVersionBlade";
import RefinedVersionEdit from "widgets/modals/versions/RefinedVersionEdit";
import RenameVersionModal from "widgets/modals/versions/RenameVersionModal";
import DuplicateVersionModal from "widgets/modals/versions/DuplicateVersionModal";
import MultiVariantModal from "widgets/modals/multi-variant/MultiVariantModal";
import AIGenerateVersionsBlade from "widgets/modals/creatives/GenerateVersionsAI/AIGenerateVersionsBlade";

export default function Modals({ libraryId, creativeId, returnPath }){
	const dispatch = useDispatch();
	let { path, url } = useRouteMatch()
		;

	function onCloseModal(){
		dispatch(push(`${url}/`));
	}

	return (
		<Switch>
			<Route
				exact
				path   = {`${path}:versionId/modal/preview-version/`}
				render = {(routeRenderProps) => {
					let { versionId } = routeRenderProps.match.params;
					return (
						<PreviewVersionBlade
							libraryId = {libraryId}
							creativeId = {creativeId}
							versionId = {versionId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}:versionId/modal/edit-version/`}
				render = {(routeRenderProps) => {
					let bladeProps = {
						libraryId,
						versionId:routeRenderProps.match.params.versionId,
						creativeId,
						onClose:onCloseModal,
					};

					return <EditVersionBlade {...bladeProps} />;
				}}
			/>
			<Route
				exact
				path   = {`${path}:versionId/modal/refined-edit-version/`}
				render = {(routeRenderProps) => {
					let bladeProps = {
						libraryId,
						versionId:routeRenderProps.match.params.versionId,
						creativeId,
						onClose:onCloseModal,
					};

					return <RefinedVersionEdit {...bladeProps} />;
				}}
			/>
			{/* <Route
				exact
				path   = {`${path}:versionId/modal/edit-version2/`}
				render = {(routeRenderProps) => {
					let bladeProps = {
						libraryId,
						versionId:routeRenderProps.match.params.versionId,
						creativeId,
						onClose:onCloseModal,
					};

					return <SocialVersionBlade {...bladeProps} />;
				}}
			/> */}
			<Route
				exact
				path   = {`${path}:versionId/modal/rename-version/`}
				render = {(routeRenderProps) => {
					let { versionId } = routeRenderProps.match.params;
					return (
						<RenameVersionModal
							libraryId = {libraryId}
							creativeId = {creativeId}
							versionId = {versionId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}:versionId/modal/duplicate-version/`}
				render = {(routeRenderProps) => {
					let { versionId } = routeRenderProps.match.params;
					return (
						<DuplicateVersionModal
							libraryId = {libraryId}
							creativeId = {creativeId}
							versionId = {versionId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}modal/multi-variant/`}
				render = {(routeRenderProps) => {
					return (
						<MultiVariantModal
							libraryId = {libraryId}
							creativeId = {creativeId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}modal/multi-variant/edit`}
				render = {(routeRenderProps) => {
					return (
						<MultiVariantModal
							libraryId = {libraryId}
							creativeId = {creativeId}
							edit = {true}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>

			<Route
				exact
				path   = {`${path}modal/generate-versions/`}
				render = {(routeRenderProps) => {
					return (
						<AIGenerateVersionsBlade
							returnPath = {returnPath}
							libraryId = {libraryId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
		</Switch>
	);
}

Modals.displayName = "VersionModals";
Modals.propTypes = {
	libraryId: PropTypes.string.isRequired,
	creativeId: PropTypes.string.isRequired,
};
